import { PrimeIcons } from 'primeng/api';

import { SochIcon } from '@shared/enum/icons';

const guides = [
  {
    id: 'condominium-profile/edit',
    title: 'Editar el perfil del condominio',
    description: 'Actualiza el nombre, NIT, datos de contacto y logo de tu condominio',
    category: 'Básico',
    icon: PrimeIcons.BUILDING,
    lastUpdated: new Date('2026-09-06'),
  },
  {
    id: 'person/create',
    title: 'Registrar personas',
    description: 'Registra las personas para tu condominio, ya sean propietarios, proveedores o terceros',
    category: 'Básico',
    icon: PrimeIcons.USERS,
    lastUpdated: new Date('2026-08-08'),
  },
  {
    id: 'provider/create',
    title: 'Registrar proveedores',
    description: 'Registra los proveedores que prestan servicios o suministran productos a tu condominio.',
    category: 'Básico',
    icon: PrimeIcons.ADDRESS_BOOK,
    lastUpdated: new Date('2026-08-08'),
  },
  {
    id: 'third-party/create',
    title: 'Registrar terceros',
    description: 'Registra los terceros necesarios para la gestión contable de tu condominio.',
    category: 'Básico',
    icon: PrimeIcons.USERS,
    lastUpdated: new Date('2026-08-08'),
  },
  {
    id: 'unit/create',
    title: 'Creación de unidades',
    description: 'Gestiona las unidades para la administración de tu condominio',
    category: 'Básico',
    icon: SochIcon.HOUSE,
    lastUpdated: new Date('2026-09-06'),
  },
  {
    id: 'unit-feature/create',
    title: 'Creación de características',
    description: 'Gestiona las características para determinar los coeficientos de tu condominio',
    category: 'Básico',
    icon: SochIcon.CLIPBOARD_LIST,
    lastUpdated: new Date('2026-08-02'),
  },
  {
    id: 'weight/create',
    title: 'Creación de ponderaciones',
    description: 'Gestiona las ponderaciones de las características de las unidades de tu condominio.',
    category: 'Básico',
    icon: SochIcon.SCALE,
    lastUpdated: new Date('2026-08-02'),
  },
  {
    id: 'line-item/create',
    title: 'Gestión de rubros',
    description: 'Crea rubros para la gestión presupuestal de tu condominio.',
    category: 'Básico',
    icon: PrimeIcons.BRIEFCASE,
    lastUpdated: new Date('2026-08-02'),
  },
  {
    id: 'budget/create',
    title: 'Gestión de presupuestos',
    description: 'Aprende a crear y gestionar presupuestos para tu condominio',
    category: 'Básico',
    icon: SochIcon.WALLET,
    lastUpdated: new Date('2026-09-06'),
  },
  {
    id: 'financial-concept/create',
    title: 'Gestión de conceptos financieros',
    description: 'Aprende a crear conceptos financieros para tu condominio',
    category: 'Básico',
    icon: PrimeIcons.TAG,
    lastUpdated: new Date('2026-08-09'),
  },
  {
    id: 'financial-rate/create',
    title: 'Gestión de tasas de interés',
    description: 'Aprende a crear tasas de interés por mora para tu condominio',
    category: 'Básico',
    icon: PrimeIcons.PERCENTAGE,
    lastUpdated: new Date('2026-08-09'),
  },
  {
    id: 'financial-discount/create',
    title: 'Gestión de descuentos',
    description: 'Aprende a crear descuentos financieros para tu condominio',
    category: 'Básico',
    icon: PrimeIcons.TICKET,
    lastUpdated: new Date('2026-08-09'),
  },
  {
    id: 'assembly-item-definition/create',
    title: 'Creación Orden del día',
    description: 'Aprende a gestionar el orden del día para las asambleas de tu condominio',
    category: 'Básico',
    icon: SochIcon.ORDER_LIST,
    lastUpdated: new Date('2026-08-02'),
  },
  {
    id: 'assembly-notice/create',
    title: 'Gestión de convocatorias',
    description: 'Aprende a gestionar convocatorias para tu condominio',
    category: 'Básico',
    icon: PrimeIcons.BELL,
    lastUpdated: new Date('2026-09-06'),
  },
  {
    id: 'location/create',
    title: 'Creación de ubicaciones',
    description: 'Aprende a gestionar ubicaciones para tu condominio',
    category: 'Básico',
    icon: PrimeIcons.MAP_MARKER,
    lastUpdated: new Date('2026-08-27'),
  },
  {
    id: 'asset/create',
    title: 'Creación de Activos',
    description: 'Aprende a crear activos para tu condominio',
    category: 'Básico',
    icon: PrimeIcons.BOX,
    lastUpdated: new Date('2026-09-06'),
  },
  {
    id: 'inspection-round/create',
    title: 'Crear rondas de inspección',
    description: 'Registra el recorrido periódico por las ubicaciones del condominio con condición y evidencia',
    category: 'Básico',
    icon: PrimeIcons.CHECK_SQUARE,
    lastUpdated: new Date('2026-09-06'),
  },
  {
    id: 'accounting-account/create',
    title: 'Crear cuentas contables',
    description: 'Gestiona el plan de cuentas jerárquico de tu condominio',
    category: 'Básico',
    icon: PrimeIcons.SITEMAP,
    lastUpdated: new Date('2026-09-06'),
  },
];

export default guides;
